export const deleteTmpAnimationObject = () => {
  for (const obj of window.canvas.getObjects()) {
    if (
      obj.giotto &&
      obj.giotto.animationParent &&
      obj.giotto.animationParent.set
    ) {
      // TODO: this might be broken after saving to json as animationParent.set is not a function
      // if (!obj.giotto.animationParent.set) {
      //   fabric.util.enlivenObjects([obj.giotto.animationParent]);
      // }
      obj.giotto.animationParent.set({
        opacity:
          obj.giotto.animationParent?.giotto?.animationParentOriginalOpacity ||
          1,
      });
      window.canvas.setActiveObject(obj.giotto.animationParent);
      window.canvas.remove(obj);
    }
  }
};
